import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import styles from './StableHeader.module.scss';
import Container from '../../../components/Container/Container';
import DropdownMenuElemToggle from '../../../components/DropDownMenu/DropdownMenuElemToggle/DropdownMenuElemToggle';
import cn from 'classnames';
import Button from '../../../components/Button/Button';
import SearchInput from '../../../components/Form/SearchInput/SearchInput';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CancelIcon from '../../../components/CancelIcon/CancelIcon';
import Paragraph from '../../../components/Typography/Paragraph/Paragraph';
import useQuery from '../../../hooks/useQuery';
import { saveFilterData } from '../../../store/reducers/Stable/slice';
import { useAppDispatch } from '../../../store/reducers';
import { useStableRoutes } from '../../../hooks/stable';
const StableHeader = ({ onClick, filters, onChange, searchInput = false }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const query = useQuery();
    const [params, setParams] = useSearchParams();
    const dispatch = useAppDispatch();
    const [searchValue, setSearchValue] = useState(params.get('name') || '');
    const { stableRoute } = useStableRoutes();
    const filtersCount = useMemo(() => Object.values(query).filter(Boolean).length, [query]);
    const reset = () => {
        setParams({});
        setSearchValue('');
        dispatch(saveFilterData({}));
    };
    const handleInputChange = (e) => {
        const { value } = e.target;
        onChange(value);
        setSearchValue(value);
    };
    return (_jsx("div", Object.assign({ className: styles.wrapper }, { children: _jsxs(Container, Object.assign({ className: cn('d-flex align-items-center', searchInput ? 'justify-content-end' : 'justify-content-between') }, { children: [!searchInput && (_jsxs("div", Object.assign({ className: 'd-flex align-items-center' }, { children: [_jsx(DropdownMenuElemToggle, { label: t('list_view'), className: styles.switcher, onClick: () => navigate(stableRoute), checked: true }), _jsxs("div", Object.assign({ className: cn(styles.box, 'd-flex align-items-center') }, { children: [_jsx(Button, { height: 'xs', color: 2, onClick: onClick, text: filters
                                        ? t('hide_filters')
                                        : t('show_filters').toLocaleUpperCase() }), filtersCount !== 0 && (_jsxs("div", Object.assign({ className: cn(styles.reset, 'd-flex align-items-center'), onClick: reset }, { children: [_jsx(CancelIcon, {}), _jsx(Paragraph, { title: `${t('reset')} (${filtersCount})` })] })))] }))] }))), _jsx("div", { children: _jsx(SearchInput, { value: searchValue, placeholder: t('search'), onChange: handleInputChange }) })] })) })));
};
export default StableHeader;
